var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bootcamp-meta"},[_c('div',{staticClass:"meta-container"},_vm._l((_vm.info),function(meta){return _c('MetaSection',{key:meta.label,attrs:{"label":meta.label,"title":meta.title,"description":meta.description}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5072b92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bootcamp/enroll/meta/TheBootcampMeta.vue
// module id = null
// module chunks = 